import styled from "styled-components";

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  padding: 20px;
  position: relative;
`

export const TopInfoWrapper = styled.div`
  display: flex;
  gap: 20px;
  margin-bottom: 20px;
  flex-wrap: wrap;
`

export const HeadWrapper = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  margin-bottom: 20px;
`

export const RightHeadContainer = styled.div`
  position: relative;
  display: flex;
  align-items: center;
  gap: 10px;
`

export const InstanceName = styled.h1`
  font-size: 24px;
  font-weight: 600;
  color: ${({theme}) => theme.palette[850]};
  margin: 0 0 10px 0;
`

export const NavWrapper = styled.div`
  display: flex;
  gap: 10px;
  margin-bottom: 20px;
`

export const BodyWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 20px;
`
